import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { userGridConfigurationMutation } from '@app/pcs/data/user-grid-configuration.mutations';
import { UserGridConfiguration } from '@app/pcs/models/user-grid-configuration';

@Injectable()
export class UserGridConfigurationDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  save(configuration: UserGridConfiguration) {
    return this.graphqlService.mutation(userGridConfigurationMutation, {
      configuration
    }, hideLoader());
  }
}
